/* eslint-disable react/no-array-index-key */
import React from "react";
import { Translate, I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import SelectComponent from "../select/Select";
import { history } from "../../routers/AppRouter";
import ROUTES from "../../data/routes";
import HeaderComponent from "../table/header/headerComponent";
import PlacesAction from "../../app/store/actions/places";
import VALIDATOR from "../../helpers/validator/formValidator";
import MultiSelect from "../multi-select/MultiSelect";

class NewPlacesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        id: "",
        codeBu: "",
        codePlace: "",
        codeState: "",
        province: "",
        codeDeposit: [],
      },
      codeStateDisabled: false,
      message: "",
      success: "",
    };
  }

  async componentDidMount() {
    const { search } = this.props.location;
    if (search) {
      const splited = search.split("=");
      const place = this.props.places[0].rows.find(
        (pl) => `${pl.id}` === splited[1]
      );
      await this.setClientUpdate(place);
    }
  }

  setClientUpdate = async (item) => {
    if (item) {
      const { form } = this.state;
      form.id = item.id;
      form.codeBu = item.codeBu;
      form.codePlace = item.codePlace;
      form.crmTag = item.crmTag;
      form.codeDeposit = item.codeDeposit
        ? item.codeDeposit.split(",")
        : [];
      
      this.setState({
        message: "",
        success: "",
        form,
        codeStateDisabled: true,
      });
    }
  };

  goBack = () =>
    history.push({
      pathname: ROUTES.PARAMETERS,
    });

  createPlace = async () => {
    const { form } = this.state;
    const codeDepositString = form.codeDeposit.join(",");

    const matchingState = this.props.places[1].find(
        (place) => place.id === form.codePlace
    );
    form.codeState = matchingState.state;
    form.province = matchingState.province;
    form.codeDeposit = codeDepositString;

    const valid = VALIDATOR.placeValidator(form);
    if (valid.success) {
        try {
            await this.props.createPlace(form);
            this.setState({
                message: "",
                success: I18n.t("placeCreated"),
                codeStateDisabled: false,
                form: {
                    id: "",
                    codeBu: "",
                    codePlace: "",
                    codeState: "",
                    province: "",
                    codeDeposit: [],
                },
            });
            this.goBack();
        } catch (err) {
            const error =
                err.response && err.response.data && err.response.data.error;
            if (error && error.code === 1617) {
                const messageError = I18n.t("placeAlreadyRegistered");
                this.setState({ message: messageError });
            } else {
                this.setState({ message: I18n.t("errorOcurred") });
            }
            form.codeDeposit = codeDepositString.split(",");
            this.setState({ form });
        }
    } else {
        this.setState({
            message: valid.message,
            success: "",
            codeStateDisabled: false,
        });
        form.codeDeposit = codeDepositString.split(",");
        this.setState({ form });
    }
  };

  updatePlace = async () => {
    const { form } = this.state;

    const matchingState = this.props.places[1].find(
      (place) => place.id === form.codePlace
    );

    form.codeState = matchingState.state;
    form.province = matchingState.province;
    form.codeDeposit;

    const valid = VALIDATOR.placeValidator(form);
    if (valid.success) {
      await this.props.updatePlace(form);
      this.setState({ message: "", success: I18n.t("placeUpdated") });
    } else {
      this.setState({ message: valid.message, success: "" });
    }
  };

  getValuesLocation = (values) =>
    values.map((val) => (
      <option key={val.id + val.crmTag} value={val.id}>
        {val.crmTag ? val.crmTag : `${val.id} - ${val.city}`}
      </option>
    ));

  getValuesBranchOptions = (index, id, name) => (
    <option key={`${index}_${id}_id`} value={id}>
      {name}
    </option>
  );

  getValuesBranch = (values) => {
    const { rows } = this.props.places[0];
    const { id, codeBu } = this.state.form;

    return values.map((val, index) => {
      // const noRegistered = !rows.find((row) => row.codeBu === val.id);
      const name = val.description;
      if (rows.length > 1) {
        if (codeBu) {
          return this.getValuesBranchOptions(
            index,
            id === 1 ? codeBu : val.id,
            name
          );
        } else {
          return this.getValuesBranchOptions(index, val.id, name);
        }
      } else {
        return this.getValuesBranchOptions(index, val.id, name);
      }
    });
  };

  selectedItem = (attr, value) => {
    const { form } = this.state;
    form[attr] = value.target.value;

    this.setState({ form, message: "", success: "" });
  };

  getSelectComponent = (
    title,
    attr,
    value,
    body,
    tooltip,
    disabled = false
  ) => (
    <SelectComponent
      title={title}
      value={value}
      body={body}
      onChange={(e) => this.selectedItem(attr, e)}
      tooltip={tooltip}
      disabled={disabled}
    />
  );

  result = async (selected) => {
    const { form } = this.state;
    form.codeDeposit = selected;
    this.setState({ form });
  };

  getValuesBodega = (values) =>
    values.map(({ description, value }) => ({ name: description, value }));

  render() {
    const { form, message, success } = this.state;
    const { id, codeBu, codePlace, codeDeposit } = form;
    const { places } = this.props;

    if (places === undefined) {
      this.goBack();
    }
    const formattedOptions = this.getValuesBodega(places[3][0]);

    return (
      <div className="main-table">
        <HeaderComponent title={I18n.t("placeRegister")} />

        <div className="form-group">
          {places[1].length &&
            this.getSelectComponent(
              I18n.t("place"),
              "codePlace",
              codePlace,
              this.getValuesLocation(places[1])
            )}
          {places[2].length &&
            this.getSelectComponent(
              I18n.t("bu"),
              "codeBu",
              codeBu,
              this.getValuesBranch(places[2]),
              ""
            )}
          <div className="form-group">
            <p style={{ marginBottom: "0px" }} className="margin-bottom-2">
              <Translate value="deposit" />
            </p>
            <MultiSelect
              options={formattedOptions}
              checked={codeDeposit}
              onSelectOptions={this.result}
              className="form-control multiSelect-input"
            />
          </div>

          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id ? (
            <button
              type="button"
              className="btn btn-dark margin"
              onClick={this.updatePlace}
            >
              <Translate value="update" />
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-dark"
              onClick={this.createPlace}
            >
              <Translate value="register" />
            </button>
          )}
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePlace: (place) => dispatch(PlacesAction.updatePlace(place)),
  createPlace: (place) => dispatch(PlacesAction.createPlace(place)),
});

const mapStateToProps = (state) => ({
  places: state.places && state.places.places,
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPlacesForm);
